import { Context } from "../../../context.js";
import { PseudoClassSelector } from "./pseudo-class.js";
/**
 * {@link https://drafts.csswg.org/selectors/#active-pseudo}
 */
export class Active extends PseudoClassSelector {
    static of() {
        return new Active();
    }
    constructor() {
        super("active");
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element, context = Context.empty()) {
        return context.isActive(element);
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (Active) {
    Active.parse = PseudoClassSelector.parseNonFunctional("active", Active.of);
})(Active || (Active = {}));
//# sourceMappingURL=active.js.map